import { useState, useEffect } from 'react';
import { httpClient } from '../common/httpclient';

export const useEnterpriseConfig = () => {

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [settings, setSettings] = useState({   
    os_banner: '',
    os_terms: '',
    os_use_vehicle: false,
    os_use_checklist: false,
    os_notify_customer_on_finish: false,
    os_auto_send_upcoming_services: false,
    maximum_stock_size: 1000,
    theme: 'light',
    text_uppercase: false,
    sale_identify_customer: true,
    sale_print_receipt: true,
    notify_wa_low_stock: false,
    notify_wa_sale_created: false,
    notify_wa_sale_canceled: false,
    notify_wa_os_billed: false,
    notify_wa_os_canceled: false,
    notify_wa_os_deleted: false
  });

  const getEnterpriseConfig = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      // Tenta primeiro o endpoint principal
      let response = await httpClient.get('/enterprise/cfg/all');
      console.log('Resposta da API /enterprise/cfg/all no hook:', response);
      
      if (response.status === 200 && response.data) {
        console.log('Configurações encontradas:', response.data);
        // Garantir que text_uppercase seja sempre boolean
        const normalizedData = {
          ...response.data,
          text_uppercase: Boolean(response.data.text_uppercase)
        };
        setSettings(normalizedData);
        return normalizedData;
      } else {
        console.warn('Resposta da API não contém dados válidos:', response);
        // Mantém os valores padrão se não houver dados
        return settings;
      }
      
    } catch (err) {
      console.error('Erro ao buscar configurações da empresa:', err);
      setError(err);
      // Mantém os valores padrão em caso de erro
      return settings;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getEnterpriseConfig();
  }, []);

  return {
    settings,
    isLoading,
    error,
    refetch: getEnterpriseConfig
  };
};
